import { useParams } from 'react-router';

/** The chart explore is editing, 0 when it is a free query. */
export const useExploreChartKey = () => {
    const params = useParams<{ chartKey: string }>();

    // 0 is the intended default value, other parts of the app rely on this unfortunately
    return Number(params.chartKey) || 0;
};
